import React from 'react';
export const CFIconChevronSmallLeft = {
    alias: 'chevron-small-left',
    defaultTitle: 'Chevron Small Left',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M13.362 17a.996.996 0 0 1-.719-.305l-3.863-4a1 1 0 0 1 .013-1.402l4-4a.999.999 0 1 1 1.414 1.414l-3.305 3.305 3.179 3.293A1 1 0 0 1 13.362 17Z' }))),
};
